export enum LiveLectureBookingStatusEnum {
  PENDING_PAYMENT = "PENDING_PAYMENT",
  CONFIRMED = "CONFIRMED",
  CANCELLED = "CANCELLED",
  ATTENDED = "ATTENDED",
  NO_SHOW = "NO_SHOW",
  REFUNDED = "REFUNDED",
}
